// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__SGdXd","btn-primary":"button_btn-primary__3xwXl","btn-secondary":"button_btn-secondary__3mPU9"};